import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  I18n,
  Utils,
  Container,
  FormFooter,
  Navigation,
  CheckButtonList,
  SimpleHeader,
} from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';
import { resetStatus } from '../../employer/actions';

export default memo(
  connect(
    function (state, ownProps) {
      return {
        saveOccHealthStatus: state.screens.employer.saveOccHealthStatus,
        errorMessage: state.screens.employer.errorMessage,
        occHealthRequirements: state.screens.employer.occHealthRequirementsData,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ resetStatus }, dispatch),
      };
    }
  )(function (props) {
    const department = props.occHealthDepartment;
    const mappedRequirements = Object.keys(props.occHealthRequirements).map((key) => {
      const req = props.occHealthRequirements[key];
      return {
        label: req.name,
        id: req.master_requirement_id,
        checked: department.requirements.some(
          (d) => d.master_requirement_id === req.master_requirement_id
        ),
        editable: true,
      };
    });
    const [selectedRequirements, setRequirements] = useState(mappedRequirements || []);

    useEffect(
      function () {
        if (props.saveOccHealthStatus === SUCCESS) Navigation.dismissAllModals();
      },
      [props.saveOccHealthStatus]
    );
    useEffect(function () {
      return function () {
        props.actions.resetStatus();
      };
    }, []);

    function handleCancel() {
      Navigation.dismissAllModals();
    }

    function handleSave() {
      const requirementIds = selectedRequirements.filter((r) => r.checked).map((r) => r.id);
      props.onSave({ ...department, requirements: requirementIds });
    }

    function handleDepartmentsSelection(departments) {
      setRequirements(departments);
    }

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        //   saveDisabled={!text?.trim()}
        cancelLabel="Cancel"
        saveLabel="Save"
      />
    );

    return (
      <Container
        scrollView={false}
        style={THEME.container}
        stickyFooter={footer}
        renderActivityOverlay={props.saveOccHealthStatus === REQUESTING}
        errorMessage={props.errorMessage?.message}
      >
        <View style={styles.listContainer}>
          <SimpleHeader label={`Select all of the requirements for ${department.name}`} />
          <CheckButtonList
            items={selectedRequirements}
            multi={true}
            scrollable={false}
            onValuesChanged={handleDepartmentsSelection}
          />
        </View>
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    alignItems: 'center',
    paddingBottom: 40,
  },
  inputContainer: {
    width: '100%',
    maxWidth: 400,
    flex: 1,
    borderWidth: 1.5,
    borderRadius: 10,
    borderColor: 'rgb(170,170,170)',
    backgroundColor: COLOR.contrast,
    padding: 10,
    paddingHorizontal: 15,
  },
  input: {
    ...THEME.input,
    ...FONT.regular,
    fontSize: __WEB__ ? 12 : 12,
  },
});
